define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MPGrowthPhaseDomain = void 0;
    class MPGrowthPhaseDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MPGrowthPhaseDomain.P1ShortLeafyGrowthInTussockOrNew, value: "P1 - short leafy growth - in tussock or new" },
                    { key: MPGrowthPhaseDomain.P2WellDevelopedLeafyTussock, value: "P2 - well developed leafy tussock" },
                    { key: MPGrowthPhaseDomain.P3StemAndSeedGrowth, value: "P3 - stem and seed growth" },
                    { key: MPGrowthPhaseDomain.P4MaturePlant, value: "P4 - mature plant" },
                    { key: MPGrowthPhaseDomain.ButtsOrCoarseStems, value: "Butts or coarse stems" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MPGrowthPhaseDomain.P1ShortLeafyGrowthInTussockOrNew] = 0;
                this.KeyIndex[MPGrowthPhaseDomain.P2WellDevelopedLeafyTussock] = 1;
                this.KeyIndex[MPGrowthPhaseDomain.P3StemAndSeedGrowth] = 2;
                this.KeyIndex[MPGrowthPhaseDomain.P4MaturePlant] = 3;
                this.KeyIndex[MPGrowthPhaseDomain.ButtsOrCoarseStems] = 4;
                this.ValueIndex = {};
                this.ValueIndex["P1 - short leafy growth - in tussock or new"] = 0;
                this.ValueIndex["P2 - well developed leafy tussock"] = 1;
                this.ValueIndex["P3 - stem and seed growth"] = 2;
                this.ValueIndex["P4 - mature plant"] = 3;
                this.ValueIndex["Butts or coarse stems"] = 4;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MPGrowthPhaseDomain = MPGrowthPhaseDomain;
    Object.defineProperty(MPGrowthPhaseDomain, "P1ShortLeafyGrowthInTussockOrNew", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MPGrowthPhaseDomain, "P2WellDevelopedLeafyTussock", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MPGrowthPhaseDomain, "P3StemAndSeedGrowth", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MPGrowthPhaseDomain, "P4MaturePlant", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MPGrowthPhaseDomain, "ButtsOrCoarseStems", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MPGrowthPhaseDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
